<template>
    <div class="beidou">
        <navs></navs>
        <!--北斗-->
        <div class="starsBox">
            <p class="starTitle">承运通-网络货运平台</p>
            <p class="beiIntro">承运通-网络货运平台主要为道路运输“货找车、车找货”提供信息技术服务。车运平台的建设是基于道路运输行业的特点，根据交通运输部网络货运平台系统接入指南要求建设而成。针对公路货运行业“多、小、散、乱”的特点，对12吨以上的重载货车和半挂牵引车进行自动监管</p>
            <div class="starsImg"></div>
        </div>
         <!--动力分布图-->

<!--        <div class="distribution">-->
<!--            <div class="titles">动力分布</div>-->
<!--            <img src="../assets/bei-map.png" class="disImg">-->
<!--            <p class="xb">西北：52000+</p>-->
<!--            <p class="xn">西南地区：18000+</p>-->
<!--            <p class="hb">华北：68000+</p>-->
<!--            <p class="hn">华南：27000+</p>-->
<!--            <p class="db">东北：26000+</p>-->
<!--            <p class="hd">华东：36000+</p>-->
<!--             <p class="hz">华中：28000+</p>-->
<!--        </div>-->
          <!--数据采集-->
        <div class="collections">
           <div class="titles">数据采集</div>
           <p class="collectSub">
            通过静态数据（车主信息、车辆信息、企业信息等）及动态数据（位置信息、速度信息、轨迹信息、异常离线、驶入驶出、行驶里程等信息）的采集分析，在信息发布、运力调度、车辆审核、驾驶监督、分段限速等维度，实现对道路货物运输的有效监管与服务
            </p>
            <div class="collectImg"></div>
        </div>
        <!---->
        <div class="product">
            <div class="titles">产品矩阵</div>
            <van-swipe :show-indicators='true'>
                <van-swipe-item>
                    <div class="proOut">
                         <img src="../assets/bei-phone.png" class="proImg">
                         <!-- <img src="../assets/bei-left.png" class="proLeft">
                         <img src="../assets/bei-right.png" class="proRight"> -->
                    </div>
                    <div class="titles">微信移动端</div>
                    <div class="titleSub" >微信搜索并关注“承运通”公众号，提供司机端、货主端、现场管理端，实名认证后即可在线进行发单、抢单等运输交易 </div>
                    <div style="padding-bottom:0.8rem"></div>
                </van-swipe-item>
                <van-swipe-item>
                    <div class="proOut1">
                         <img src="../assets/bei-computer.png" class="proImg">
                         <!-- <img src="../assets/bei-left.png" class="proLeft">
                         <img src="../assets/bei-right.png" class="proRight"> -->
                    </div>
                    <div class="titles">SaaS业务管理系统</div>
                    <div class="titleSub"> 为货主、贸易企业、司机、承运公司等行业相关群体提供PC端SaaS业务管理系统，方便对业务进行可视化、数字化管理</div>
                </van-swipe-item>

            </van-swipe>
        </div>
        <div style="margin-top:1rem"></div>
        <foot></foot>
       <rightC></rightC>
    </div>
</template>
<script>
import navs from '@/components/nav/head';
import foot from '@/components/nav/footer'
import rightC from '@/components/nav/rightFloat'
export default {
    name:'beiodu',
    data(){
        return{
          current: 0
        }
    },
    components:{
     navs,foot,rightC
    },
    created(){

    }
}
</script>
<style lang='less' rel='stylesheet/less'>
   @rem:16rem;
   @col-f:#fff;
   .starsBox{
       width: 100%;
       height: 428/@rem;
       background: #020E39;
        text-align: center;
       .starTitle{
           padding-top: 30/@rem;
            font-size: 18/@rem;
             text-align: center;
             color:  @col-f;
            font-weight: 300;
       }
       .beiIntro{
           font-size: 10/@rem;
            color:  @col-f;
            padding-left: 19/@rem;
            padding-right:19/@rem;
            font-weight: 300;
         text-align: left;
            line-height: 20/@rem
       }
       .starsImg{
           width: 100%;
           height: 228/@rem;
            background: url('../assets/bei-b.png');
            background-repeat: no-repeat;
            background-position: center bottom;
            background-size: 290/@rem 210/@rem;
       }
   }
  .titles{
       font-size: 18/@rem;
       text-align: center;
       color:  #333;
       font-weight: 300;
  }
  .distribution{
      margin-top: 1.2rem;
      position:relative;
      height: 330/@rem;
      .disImg{
          width: 300/@rem;
          position: absolute;
          left: 50%;
          margin-left: -(300/@rem)/2;
          top: 2.8rem;

      }
      p{
          color: #666666;
          font-size: 9/@rem
      }
      .xb{
          position: absolute;
          top: 4.44rem;
          left: 0.44rem;
      }
      .xn{
          position: absolute;
          bottom: 4.34rem;
          left: 0.72rem;
      }
      .hn{
          position: absolute;
          bottom: 2.40rem;
          left: 6.02rem;
      }
      .hb{
           position: absolute;
          top: 3.44rem;
          left:7.42rem;
      }
      .db{
          position: absolute;
          top: 2.4rem;
          right:0.66rem;
      }
      .hd{
           position: absolute;
          top: 7.9rem;
          right:1.66rem;
      }
      .hz{
           position: absolute;
          bottom: 4.4rem;
          right:1.28rem;
      }
  }
  .collections{
       padding: 22/@rem 16/@rem;
       background: url('../assets/bei-shu-bg.png');
       background-repeat: no-repeat;
       background-position: center bottom;
       background-size: 100% 100%;
      .collectSub{
          font-size: 10/@rem;
          color: #666;
          text-align: justify;
          text-align-last: center;

      }
      .collectImg{
            width: 100%;
            height: 168/@rem;
            background: url('../assets/bei-shu.png');
            background-repeat: no-repeat;
            background-position: center bottom;
            background-size: 260/@rem 168/@rem;
      }



  }
  .product{
      padding-top: 22/@rem;
        .proOut{
            position:relative;
            width: 100%;
            height: 340/@rem;
            // margin-top: 20/@rem;
            .proImg{
                width: 280/@rem;
                height: 300/@rem;
                position: absolute;
                left: 50%;
                top: 50%;
                margin-left:-(280/@rem)/2;
                margin-top:-(300/@rem)/2;
            }
            .proLeft{
                width: 12/@rem;
                height: 20/@rem;
                position: absolute;
                left: 16/@rem;
                top: 50%;
                margin-top:-(20/@rem)/2;
            }
             .proRight{
                width: 12/@rem;
                height: 20/@rem;
                position: absolute;
                right: 16/@rem;
                top: 50%;
                margin-top:-(20/@rem)/2;
            }
        }
         .proOut1{
            position:relative;
            width: 100%;
            height: 320/@rem;
            // margin-top: 20/@rem;
            .proImg{
                width: 240/@rem;
                height: 278/@rem;
                position: absolute;
                left: 50%;
                top: 55%;
                margin-left:-(240/@rem)/2;
                margin-top:-(278/@rem)/2;
            }
            .proLeft{
                width: 12/@rem;
                height: 20/@rem;
                position: absolute;
                left: 16/@rem;
                top: 50%;
                margin-top:-(20/@rem)/2;
            }
             .proRight{
                width: 12/@rem;
                height: 20/@rem;
                position: absolute;
                right: 16/@rem;
                top: 50%;
                margin-top:-(20/@rem)/2;
            }
        }
        .titleSub{
            font-size: 10/@rem;
            color:#666;
            padding-left:  16/@rem;
            padding-right:  16/@rem;
            text-align: center;
            margin-top: 20/@rem;
            line-height: 18/@rem
        }
  }

</style>



// WEBPACK FOOTER //
// src/components/beidou.vue